<template>
    <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6">
              <h2 class="card-title">Plan de Prévention Evolutif</h2>
        </div>
      </div>
      <router-link class="btn btn-secondary btn-sm " to="/login">← Retour</router-link> 
      <div class="row">
        
        

        <form class="col-md-6" validated @submit="onSubmit" >
            <card class="bg-light login-bloc">
              <template slot="header">
                <h4 class="card-title">Réinitialisez votre mot de passe</h4>
                <p class="card-category">Vous avez déjà un compte sur PPE mais vous avez oublié votre mot de passe</p>
              </template>

              <b-form-group
                label="Votre email de connexion"
                label-for="login"
                description="L'email qui vous a servi lors de votre inscription sur PPE"
                class=""
                aria-errormessage="please enter"
              >
                <b-form-input
                  id="login"
                  type="email"
                  v-model="form.login"
                  placeholder="Votre email de connexion"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group class="float-right">
                <b-button type="submit" variant="primary">Envoyer un email</b-button>
              </b-form-group>
            </card>
        </form>
      </div>
    </div>
    </div>    
</template>
<style scoped>
.login-bloc {
  height: 250pt;
}
</style>
<script>
import Card from "../components/Cards/Card.vue";
import swal from "sweetalert";
import common from './common/pages.js'

export default {
  components: {
    Card,
  },
  data() {
    return  {
      form: {
        login : ''
      }
    }
  },
    methods: {
      ...common.methods,
      async onSubmit(event) {
        event.preventDefault()
        console.log("JSON.stringify(this.form)",JSON.stringify(this.form))

        try {
          //console.log("BEFORE LOGIN", this.form)
          let response = await this.$http.post("/user/reset", this.form );
          console.log("RESPONSE", response.data)
          if(response.data.status === 404) {
            swal({title:"Email erroné", text:"L'adresse " + this.form.login + " ne semble pas exiter dans nos fichiers.", icon:"warning", buttons: 'OK'} );
          } else {
            swal({title:"Email envoyé", text:"Nous avons fait parvenir un email à l'adresse " + this.form.login + " pour réinitialiser votre mot de passe. Vérifiez votre boite mail et vos spams / courriers indésirables.", icon:"success", buttons: 'OK'} );
          }
          this.$router.push("/login")
          
        } catch (err) {
          swal("Erreur", err.response? (err.response.data.error) : JSON.stringify(err), "error");
          console.log(err.response.data.error);
        }
      },
    }
}
</script>
